import axios from "axios";

axios.defaults.baseURL = "https://web.boxthemes.com"
axios.defaults.headers.Authorization = localStorage.getItem("token");

export default axios;
